document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".slider-snap-wrapper");

  if (!containers.length) return;

  containers.forEach((slide) => {
    const id = slide.getAttribute("id");
    if (!id) return;

    const bar = document.getElementById(`scroll-${id}`);
    if (!bar) return;

    const barWrapper = bar.parentElement;

    // ===== INIT WIDTH =====
    const updateBarWidth = () => {
      const totalScrollWidth = slide.scrollWidth;
      const visibleWidth = slide.clientWidth;

      if (totalScrollWidth <= 0) return;

      // width of custom bar based on visible area ratio
      const widthRatio = visibleWidth / totalScrollWidth;
      bar.style.width = `${widthRatio * 100}%`;

      updateBarPosition(); // re-sync position after resize
    };

    // ===== UPDATE POSITION =====
    const updateBarPosition = () => {
      const maxScroll = slide.scrollWidth - slide.clientWidth;

      if (maxScroll <= 0) {
        bar.style.transform = `translateX(0px)`;
        return;
      }

      const progress = slide.scrollLeft / maxScroll;

      const maxTranslate = barWrapper.clientWidth - bar.clientWidth;

      bar.style.transform = `translateX(${progress * maxTranslate}px)`;
    };

    // ===== EVENTS =====
    updateBarWidth();

    window.addEventListener("resize", updateBarWidth);
    slide.addEventListener("scroll", updateBarPosition);
  });
});
